var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instruction"},[(_vm.item.params.image_id)?_c('img',{attrs:{"src":_vm.imageUrl(_vm.item.params.image_id),"alt":_vm.item.params.image_id}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }